module.exports = __webpack_public_path__ + "img/yyLogo.5e7fc814.png";